import { render, staticRenderFns } from "./SchoolSearch.vue?vue&type=template&id=7b2d53a1&scoped=true&"
import script from "./SchoolSearch.vue?vue&type=script&lang=js&"
export * from "./SchoolSearch.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSearch.vue?vue&type=style&index=0&id=7b2d53a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d53a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCombobox,VListItemContent,VListItemTitle})
